/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./test-account.vue?vue&type=template&id=6637dfdc&scoped=true&"
import script from "./test-account.vue?vue&type=script&lang=js&"
export * from "./test-account.vue?vue&type=script&lang=js&"
import style0 from "./test-account.vue?vue&type=style&index=0&id=6637dfdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637dfdc",
  null
  
)

export default component.exports